import LogIn from "./LogIn";
import AccountInfo from "./AccountInfo";
import {useContext, useEffect} from "react";
import {UserContext} from "../../contexts/UserContext";
import {WallContext} from "../../contexts/WallContext";

export default function SidePersonal() {
    const user = useContext(UserContext);

    const wall = useContext(WallContext);
    useEffect(() => {
        if (wall === null || user.value === null)
            return;
        user.value.wireUpWallRoutes(wall);
    }, [user, wall])

    return (
        <>
            { user.value === null &&
                <LogIn/>
            }
            { user.value !== null &&
                <AccountInfo user={user}/>
            }
        </>
    )
}